var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingplanBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 40,
    viewBox: "0 0 21 40",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_240_708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.649414 40L0.649417 3.20259L2.98528 0.870185L20.6494 0.870186L20.6494 37.6781L18.3011 40L0.649414 40Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.699413 39.95L0.699417 3.22332L3.00597 0.920184L20.5994 0.920185L20.5994 37.6573L18.2806 39.95L0.699413 39.95Z",
    stroke: "url(#paint0_linear_240_708)",
    strokeOpacity: 0.5,
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.699413 39.95L0.699417 3.22332L3.00597 0.920184L20.5994 0.920185L20.5994 37.6573L18.2806 39.95L0.699413 39.95Z",
    stroke: "url(#paint1_linear_240_708)",
    strokeOpacity: 0.5,
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_240_708",
    x: -14.3506,
    y: -14.1299,
    width: 50,
    height: 69.1299,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_240_708"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_240_708",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_708",
    x1: 21.071,
    y1: 30.3874,
    x2: 5.36986,
    y2: 25.2833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_708",
    x1: -0.831855,
    y1: -5.37415,
    x2: 6.83816,
    y2: -3.49332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingplanBackground);
export default __webpack_public_path__ + "static/media/pricingplanBackground.a40cc13ff9e858120878d7cc29d60131.svg";
export { ForwardRef as ReactComponent };